import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=5281f749&scoped=true&"
import script from "./questionList.vue?vue&type=script&lang=ts&"
export * from "./questionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5281f749",
  null
  
)

export default component.exports